import React, { Component } from 'react';
import { connect } from 'react-redux';
import animationSettings from '../config/animation-settings';

class AnimationMap extends Component {

    render() {
        const { activeStage, choicesAreAvailable } = this.props;
        const { animationStages } = animationSettings;
        const numOfStages = animationStages.length;

        let finalClassName = "animation-map-icon";
        if( choicesAreAvailable ) {
            finalClassName += " current";
        }

        return(
            <div className="animation-map-container">
                { [...Array(numOfStages)].map((stage,stageKey) => {
                    let className = "animation-map-icon";
                    if( stageKey + 1 === activeStage && !choicesAreAvailable ) {
                        className += " current";
                    }else if( stageKey + 1 < activeStage && !choicesAreAvailable ) {
                        className += " past";
                    }

                    return <div key={ stageKey } className={ className } />;
                })}
                <div className={ finalClassName } />
            </div>
        );
    }

}

const mapStateToProps = ( state ) => {
    return{
        activeStage: state.animationStage,
        choicesAreAvailable: state.chooseABacteriaStatus
    }
}

export default connect(mapStateToProps)(AnimationMap);



// WEBPACK FOOTER //
// ./src/components/animation-map.js